import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ArrowRightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="m15.5 8-7.2 7.2-1.5-1.4L11.6 9h-10V7h10L6.8 2.2 8.3.8 15.5 8Z"
        data-testid="icon-arrowRight"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
